var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PagePlaceholder',{attrs:{"title":_vm.$t(_vm.Retailers.RetailerCard.retailerProfile)}})
}
var staticRenderFns = []

export { render, staticRenderFns }